import * as React from 'react'
import { memo } from 'react'
const SvgCheck = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="m5.954 10.134 4.954-4.954-.777-.776-4.177 4.177-2.1-2.1-.777.776Zm1.045 3.865a6.8 6.8 0 0 1-2.73-.551 7.1 7.1 0 0 1-2.223-1.5 7.1 7.1 0 0 1-1.5-2.222 6.8 6.8 0 0 1-.547-2.727 6.8 6.8 0 0 1 .551-2.73 7.1 7.1 0 0 1 1.5-2.223 7.1 7.1 0 0 1 2.222-1.5 6.8 6.8 0 0 1 2.727-.547 6.8 6.8 0 0 1 2.73.551 7.1 7.1 0 0 1 2.223 1.5 7.1 7.1 0 0 1 1.5 2.222 6.8 6.8 0 0 1 .547 2.727 6.8 6.8 0 0 1-.551 2.73 7.1 7.1 0 0 1-1.5 2.223 7.1 7.1 0 0 1-2.222 1.5 6.8 6.8 0 0 1-2.727.547" />
  </svg>
)
const Memo = memo(SvgCheck)
export default Memo
